import SocialMedia from "./SocialMedia";

const FooterBottom = ({ data }: { data: any }) => {
	return (
		<>
			<div className="copyRight text-white text-bodyM flex-row w-100 lg:w-[25%] order-2 lg:order-none mb-8 lg:mb-0 text-center lg:text-start font-bodyM ">
				<p suppressHydrationWarning>© {new Date().getFullYear()} O West. All rights reserved</p>
			</div>
			<div className="social-media flex-row w-[100%] lg:w-[40%] order-1 lg:order-none  mb-16 lg:mb-0">
				<SocialMedia data={data} />
			</div>
			<div className="createBy flex-row w-[100%] xl:w-[24.5%] lg:w-[23%] order-3 lg:order-none  text-center lg:text-start ">
				<p className="signature-en text-white text-bodyM ">
					<span className="crafted-by font-signature-en">
						Crafted by &nbsp;
					</span>
					<a
						href="https://paralleltech.solutions/"
						target="_blank"
						className="font-gotham cursor-pointer "
					>
					 parallel
					</a>
				</p>
			</div>
		</>
	);
};

export default FooterBottom;
